import { EnableFaceBook } from "../../Helpers/analytics";
import {
  SAVE_ADDRESS,
  SAVE_CONTACT,
  MODIFY_ADDRESS,
  SAVE_CAR_INFO,
  UPDATE_MOV,
  RESET_DELIVERY_TYPE,
  UPDATE_PROMOTION,
  SET_ORDERPASS_DATA,
  CLEAR_ORDERPASS_DATA,
  SET_ORDERPASS_GUEST_BYPASS,
  CLEAR_ORDERPASS_GUEST_BYPASS,
} from "./actionTypes";
import instance from "./instance";
import { saveLatestAbandonedCart } from "./abandonedCartSync";
import {
  getOrderPassDomain,
  getOrderPassSavedAreaNames,
  hydrateOrderPassAddresses,
  isOrderPassEnabled,
  normalizeOrderPassPhone,
} from "../../Helpers/orderPass";
import { fetchTargetedDeliveryChargesForAreas } from "./store";

export const saveAddress = (address) => {
  return async (dispatch, getState) => {
    const newAddress = address;
    delete newAddress.blockError;
    delete newAddress.streetError;
    await dispatch({
      type: SAVE_ADDRESS,
      payload: newAddress,
    });

    const smart_promos = getState().store.store.smart_promos;
    const storeSettings = getState().store?.store?.settings || {};
    const customer = getState().customers;
    const branchDetails = getState().branch;
    const authUser = getState().auth.user;
    const storeCategories = getState().store.store.categories;
    const deliveryTime = getState().deliveryTime;

    await dispatch({
      type: UPDATE_PROMOTION,
      smart_promos: smart_promos,
      customerAddress: customer?.address || {},
      customerBin: customer?.bin || {},
      branchDetails: branchDetails,
      updatePromotionQuantity: false,
      authUser: authUser,
      storeCategories: storeCategories,
      storeSettings,
      deliveryTime,
    });
    await saveLatestAbandonedCart(dispatch, getState);
  };
};

export const modifyAddress = (address) => {
  return async (dispatch, getState) => {
    await dispatch({ type: MODIFY_ADDRESS, payload: address });
    const smart_promos = getState().store.store.smart_promos;
    const storeSettings = getState().store?.store?.settings || {};
    const customer = getState().customers;
    const branchDetails = getState().branch;
    const authUser = getState().auth.user;
    const storeCategories = getState().store.store.categories;
    const deliveryTime = getState().deliveryTime;

    await dispatch({
      type: UPDATE_PROMOTION,
      smart_promos: smart_promos,
      customerAddress: customer?.address || {},
      customerBin: customer?.bin || {},
      branchDetails: branchDetails,
      updatePromotionQuantity: false,
      authUser: authUser,
      storeCategories: storeCategories,
      storeSettings,
      deliveryTime,
    });

    await saveLatestAbandonedCart(dispatch, getState, {
      requireCartItems: true,
    });
  };
};

export const saveCustomerContact = (customer) => {
  return async (dispatch, getState) => {
    const settings = getState().store?.store?.settings;
    const newCustomerContact = {
      name: customer.name,
      phone: customer.phone,
      email: customer.email,
      civilID: customer.civilID,
      birth_date: customer.birthday,
      opt_in_marketing: customer.optInMarketing,
      contact_channel: customer.contactChannel,
    };
    await dispatch({
      type: SAVE_CONTACT,
      payload: newCustomerContact,
    });

    if (settings?.enable_fb_pixel && settings?.fb_pixel) {
      EnableFaceBook(settings, newCustomerContact); // tO update customer's info
    }
    await saveLatestAbandonedCart(dispatch, getState, {
      requireCartItems: true,
    });
  };
};

export const setOrderPassData = (data) => {
  return {
    type: SET_ORDERPASS_DATA,
    payload: data,
  };
};

export const clearOrderPassData = () => {
  return {
    type: CLEAR_ORDERPASS_DATA,
  };
};

export const setOrderPassGuestBypass = (phone) => {
  return {
    type: SET_ORDERPASS_GUEST_BYPASS,
    payload: normalizeOrderPassPhone(phone),
  };
};

export const clearOrderPassGuestBypass = () => {
  return {
    type: CLEAR_ORDERPASS_GUEST_BYPASS,
  };
};

export const refreshStorefrontOrderPassData = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const store = state.store.store;
    const settings = store?.settings || {};
    const verifiedPhone = state.customers.orderPassVerifiedPhone;
    const storefrontToken = state.customers.orderPassStorefrontToken;

    if (!store) return false;

    if (!isOrderPassEnabled(settings)) {
      if (
        state.customers.orderPassPhone ||
        verifiedPhone ||
        storefrontToken ||
        state.customers.orderPassLinked ||
        state.customers.orderPassGuestBypassPhone ||
        (state.customers.orderPassAddresses || []).length
      ) {
        dispatch({ type: CLEAR_ORDERPASS_DATA });
      }
      return false;
    }

    const normalizedPhone = normalizeOrderPassPhone(verifiedPhone);
    if (!normalizedPhone || !storefrontToken) return false;

    const clearStaleOrderPassSession = () => {
      dispatch({ type: CLEAR_ORDERPASS_DATA });
      return false;
    };

    try {
      const res = await instance.post("/order_pass/storefront_account/", {
        domain: getOrderPassDomain(settings, store),
        storefront_token: storefrontToken,
      });

      if (!res.data?.success || !res.data?.account) {
        return clearStaleOrderPassSession();
      }

      const account = res.data.account;
      if (
        settings.is_branch_based_ordering &&
        Array.isArray(account.addresses) &&
        account.addresses.length
      ) {
        const currentState = getState();
        const selectedBranchDeliveryChargeId = currentState.branch?.bdc || null;
        const selectedDeliveryChargeId =
          (currentState.store.store?.branch_delivery_charges || []).find(
            (bdc) => bdc.id == selectedBranchDeliveryChargeId,
          )?.delivery_charge || null;

        await dispatch(
          fetchTargetedDeliveryChargesForAreas({
            countryCode: currentState.store.store?.country_code,
            areaNames: getOrderPassSavedAreaNames(account.addresses),
            selectedBranchDeliveryChargeId,
            selectedDeliveryChargeId,
          }),
        );
      }

      const refreshedState = getState();
      const refreshedAddresses = hydrateOrderPassAddresses(
        account.addresses || [],
        {
          settings: refreshedState.store.store?.settings || settings,
          areas: refreshedState.store.store?.areas || [],
          branchDeliveryCharges:
            refreshedState.store.store?.branch_delivery_charges || [],
          countries:
            refreshedState.store.store?.all_countries ||
            refreshedState.store.store?.countries ||
            [],
        },
      );
      const currentCustomerContact = getState().customers.customerContact || {};
      const refreshedPhone = normalizeOrderPassPhone(
        account.phone_number || normalizedPhone,
      );

      dispatch({
        type: SAVE_CONTACT,
        payload: {
          ...currentCustomerContact,
          name: account.full_name || currentCustomerContact.name || "",
          email: account.email || currentCustomerContact.email || "",
          phone: refreshedPhone || currentCustomerContact.phone || "",
        },
      });

      dispatch({
        type: SET_ORDERPASS_DATA,
        payload: {
          phone: refreshedPhone,
          addresses: refreshedAddresses,
          verifiedPhone: refreshedPhone,
          linked: true,
          storefrontToken:
            res.data?.storefront_token ||
            getState().customers.orderPassStorefrontToken ||
            "",
        },
      });

      const currentAddress = getState().customers.address;
      if (
        currentAddress?.orderPassAddressId &&
        currentAddress?.selectedDeliveryType === 0
      ) {
        const matchingAddress = refreshedAddresses.find(
          (address) =>
            address.orderPassAddressId === currentAddress.orderPassAddressId,
        );
        const nextSelectedAddress = matchingAddress?.checkoutAddress
          ? matchingAddress
          : null;

        if (nextSelectedAddress?.checkoutAddress) {
          dispatch({
            type: "SWITCH_ADDRESS",
            payload: {
              address: nextSelectedAddress,
              isBranchBased: settings.is_branch_based_ordering,
            },
          });

          if (
            settings.is_branch_based_ordering &&
            nextSelectedAddress.branch_delivery_charge_id &&
            nextSelectedAddress.branch_delivery_charge__branch__id
          ) {
            dispatch({
              type: "SET_BRANCH_DELIVERY_CHARGE",
              payload: {
                bdc: nextSelectedAddress.branch_delivery_charge_id,
                branch: nextSelectedAddress.branch_delivery_charge__branch__id,
                isPickup: false,
              },
            });
            dispatch({
              type: UPDATE_MOV,
              payload:
                refreshedState.store.store?.branch_delivery_charges?.find(
                  (bdc) =>
                    bdc.id == nextSelectedAddress.branch_delivery_charge_id,
                )?.minimum_order_value || 0,
            });
          }
        } else {
          dispatch({
            type: MODIFY_ADDRESS,
            payload: {
              orderPassAddressId: null,
            },
          });
        }
      }

      return {
        account,
        addresses: refreshedAddresses,
      };
    } catch (error) {
      const status = error?.response?.status;
      if (status === 401 || status === 404) {
        return clearStaleOrderPassSession();
      }
      return false;
    }
  };
};

export const saveCarInfo = (type, value) => {
  return {
    type: SAVE_CAR_INFO,
    payload: { type: type, value: value },
  };
};

export const resetDeliveryType = () => {
  return {
    type: RESET_DELIVERY_TYPE,
  };
};
